export class CartSettings
{
  public static trial_live_session_url = "";
  public static verbal_live_session_url = "";
  //public static verbal_live_session_url_m1 = "https://e-gmat.com/gmat-preparation-courses/";
  public static verbal_live_session_url_m1 = "https://e-gmattest.com/secure/cart/?q=cart/add/p188";
  public static verbal_live_session_url_m2 = "https://e-gmat.com/secure/cart/?q=cart/add/p203_q1_a5o12";
  public static verbal_live_session_url_m3 = "https://e-gmat.com/secure/cart/?q=cart/add/p203_q1_a5o12";
}
